(function() {
  if (window.__sportDropdownInit) return;
  window.__sportDropdownInit = true;

  function positionMenu(toggle, menu, dropdown) {
    var rect = toggle.getBoundingClientRect();
    var viewportH = window.innerHeight;
    var spaceBelow = viewportH - rect.bottom;
    var spaceAbove = rect.top;
    var gap = 8;

    menu.style.position = 'fixed';
    menu.style.left = rect.left + 'px';
    menu.style.width = rect.width + 'px';
    menu.style.display = 'flex';
    menu.style.flexDirection = 'column';
    menu.style.maxHeight = '';
    menu.style.top = '-9999px';
    menu.style.bottom = 'auto';

    var menuHeight = menu.offsetHeight;
    var showAbove = spaceBelow < menuHeight && spaceAbove > spaceBelow;

    var maxHeightCap = 320;

    if (showAbove) {
      var maxAbove = Math.min(maxHeightCap, Math.max(0, spaceAbove - gap));
      menu.style.maxHeight = maxAbove + 'px';
      menu.style.top = 'auto';
      menu.style.bottom = (viewportH - rect.top) + 'px';
      menu.style.flexDirection = 'column-reverse';
      dropdown.classList.add('sport-dropdown--up');
      menu.classList.add('sport-dropdown__menu--up');
      menu.scrollTop = menu.scrollHeight;
    } else {
      var maxBelow = Math.min(maxHeightCap, Math.max(0, spaceBelow - gap));
      menu.style.maxHeight = maxBelow + 'px';
      menu.style.top = rect.bottom + 'px';
      menu.style.bottom = 'auto';
      dropdown.classList.remove('sport-dropdown--up');
      menu.classList.remove('sport-dropdown__menu--up');
      menu.scrollTop = 0;
    }
  }

  function closeDropdown(dropdown) {
    dropdown.classList.remove('is-open');
    dropdown.classList.remove('sport-dropdown--up');
    var toggle = dropdown.querySelector('.sport-dropdown__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    var menu = dropdown.__sdMenu;
    if (menu) {
      menu.style.cssText = '';
      menu.classList.remove('sport-dropdown__menu--up');
      if (menu.parentNode !== dropdown) {
        dropdown.appendChild(menu);
      }
    }
  }

  function initSportDropdowns(scope) {
    var root = scope || document;
    root.querySelectorAll('.sport-dropdown').forEach(function(dropdown) {
      if (dropdown.dataset.sdInit) return;
      dropdown.dataset.sdInit = 'true';
      var toggle = dropdown.querySelector('.sport-dropdown__toggle');
      var menu = dropdown.querySelector('.sport-dropdown__menu');
      if (!toggle || !menu) return;
      dropdown.__sdMenu = menu;

      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        var wasOpen = dropdown.classList.contains('is-open');
        document.querySelectorAll('.sport-dropdown.is-open').forEach(function(other) {
          if (other !== dropdown) closeDropdown(other);
        });
        if (wasOpen) {
          closeDropdown(dropdown);
        } else {
          dropdown.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          document.body.appendChild(menu);
          positionMenu(toggle, menu, dropdown);
        }
      });
    });
  }

  initSportDropdowns();

  document.addEventListener('click', function(e) {
    document.querySelectorAll('.sport-dropdown.is-open').forEach(function(dropdown) {
      var menu = dropdown.__sdMenu;
      if (!dropdown.contains(e.target) && (!menu || !menu.contains(e.target))) {
        closeDropdown(dropdown);
      }
    });
  });

  window.addEventListener('scroll', function() {
    document.querySelectorAll('.sport-dropdown.is-open').forEach(function(dropdown) {
      var toggle = dropdown.querySelector('.sport-dropdown__toggle');
      var menu = dropdown.__sdMenu;
      if (toggle && menu && menu.style.display === 'flex') positionMenu(toggle, menu, dropdown);
    });
  }, { passive: true });

  window.addEventListener('resize', function() {
    document.querySelectorAll('.sport-dropdown.is-open').forEach(function(dropdown) {
      var toggle = dropdown.querySelector('.sport-dropdown__toggle');
      var menu = dropdown.__sdMenu;
      if (toggle && menu && menu.style.display === 'flex') positionMenu(toggle, menu, dropdown);
    });
  });

  document.addEventListener('shopify:section:load', function(e) {
    initSportDropdowns(e.target);
  });
})();
